import { Grid, CardHeader, CardContent, Box, Select, FormHelperText, MenuItem, TextField, CircularProgress, Avatar, Button } from "@mui/material";
import React, { useState, useRef, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { Form, FormikProvider, useFormik } from "formik";
import { IMAGE_BASE, REMOVEHTML, REMOVENBSP } from "../../utils/constants";
import LoadingButton from "@mui/lab/LoadingButton";
import CardLayout from "../../layouts/CardLayout";
import { toast } from "react-toastify";
import errorHandler from "../../utils/errorHandler";
import { ShareReferServices } from "../../services/AllServices";
import EdiorJodit from "../../components/editor/editorJodit";
import { ShareTaskSchema } from "../../utils/Schema";
import { trimFormValues } from "../../utils/helpers";

function AddEditCategory() {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [imageLoading, setImageLoading] = useState(false);
    const [selectedImage, setSelectedImage] = useState(null);
    const [imagePreview, setImagePreview] = useState(null);
    const [cmsData, setCmsData] = useState("");
    const fileInputRef = useRef(null);
    const [data, setData] = useState();
    const fetchTaskData = useCallback(async () => {
        setLoading(true);
        try {
            const response = await ShareReferServices.getData();
            const resData = response?.data?.data;
            setImagePreview(IMAGE_BASE + resData?.thumbnail);
            setData(resData);
            setCmsData(resData?.notice)
            setLoading(false);
        } catch (error) {
            errorHandler(error);
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchTaskData();
    }, [fetchTaskData]);

    const formik = useFormik({
        enableReinitialize: true,
        validationSchema: ShareTaskSchema,
        initialValues: {
  title: data?.title || "",
  shareNumber: data?.shareNumber || "",
  freeBidsGranted: data?.freeBidsGranted || "",
  freeBidsOnSignup: data?.freeBidsOnSignup || "",
  referalUserBids: data?.firstPurchaseStatics?.referalUserBids || "",
  referredByUserBids: data?.firstPurchaseStatics?.referredByUserBids || "",
  notice: data?.notice || "",
  image: data?.thumbnail || "",
  status: data?.status ? true : false,
},
        onSubmit: async (values) => {
            setLoading(true);
            try {
                // Trim all string values in the form values
                const trimmedValues = trimFormValues(values);
                
                const formData = new FormData();
                formData.append("title", trimmedValues.title);
                formData.append("shareNumber", trimmedValues.shareNumber);
                formData.append("freeBidsGranted", trimmedValues.freeBidsGranted);
                formData.append("notice", trimmedValues.notice);
                formData.append("status", trimmedValues.status);
                formData.append("imagePath", "task");
                formData.append("freeBidsOnSignup", trimmedValues.freeBidsOnSignup);
formData.append("firstPurchaseStatics[referalUserBids]", trimmedValues.referalUserBids);
formData.append("firstPurchaseStatics[referredByUserBids]", trimmedValues.referredByUserBids);

                if (selectedImage && selectedImage !== data?.image) {
                    formData.append("image", selectedImage);
                }
                const response = await ShareReferServices.update(formData);

                toast.success(response?.data?.message, { toastId: "success" });
                // navigate(-1);
            } catch (error) {
                console.error(error);
                errorHandler(error);
            } finally {
                setLoading(false);
            }
        },
    });

    const handleImageChange = (event) => {
        const file = event.currentTarget.files[0];
        const validTypes = ["image/jpeg", "image/png", "image/gif"];

        if (selectedImage && selectedImage.name === file?.name) {
            toast.error("You cannot upload the same image again.");
            fileInputRef.current.value = "";
            return;
        }

        if (file && validTypes.includes(file.type)) {
            setImageLoading(true);
            setSelectedImage(file);
            setImagePreview(URL.createObjectURL(file));
            formik.setFieldValue("image", file);
            setTimeout(() => {
                setImageLoading(false);
            }, 2000);
        } else {
            toast.error("Please upload a valid image (JPEG, PNG, or GIF).");
            fileInputRef.current.value = "";
        }
    };

    return (
        <Box>
            <CardLayout>
                <CardHeader title={`Share On Social Media Task`} />
                <CardContent>
                    <FormikProvider value={formik}>
                        <Form autoComplete="off" noValidate onSubmit={formik.handleSubmit}>
                            <Grid container spacing={3}>
                                <Grid size={{ xs: 12 }} md={12}>
                                    <input
                                        accept="image/*"
                                        type="file"
                                        ref={fileInputRef}
                                        onChange={handleImageChange}
                                        style={{ display: "none" }}
                                    />

                                    <Box
                                        mt={2}
                                        onClick={() => fileInputRef.current.click()}
                                        className="upload-box"
                                    >
                                        {imageLoading ? (
                                            <CircularProgress size={24} />
                                        ) : (
                                            <Avatar
                                                src={imagePreview || "/path/to/default-avatar.jpg"}
                                                alt="preview"
                                                className="avatar"
                                            />
                                        )}
                                    </Box>
                                    {formik.touched.image && formik.errors.image ? (
                                        <div className="error-msg error-category">
                                            {formik.errors.image}
                                        </div>
                                    ) : null}

                                    <Box mt={2} display="flex" justifyContent="center">
                                        <Button
                                            size="large"
                                            type="button"
                                            variant="contained"
                                            onClick={() => fileInputRef.current.click()}
                                        >
                                            Upload Image
                                        </Button>
                                    </Box>
                                </Grid>

                                <Grid size={{ xs: 6 }} md={6}>
                                    <TextField
                                        fullWidth
                                        label="Title"
                                        value={formik.values.title}
                                        onChange={formik.handleChange}
                                        name="title"
                                        error={Boolean(formik.touched.title && formik.errors.title)}
                                        helperText={formik.touched.title && formik.errors.title}
                                        inputProps={{ maxLength: 100 }}
                                    />
                                </Grid>

                                <Grid size={{ xs: 6 }} md={6}>
                                    <TextField
                                        fullWidth
                                        label="Share Number To Complete Milestone"
                                        value={formik.values.shareNumber}
                                        onChange={(e) => {
                                            const value = e.target.value.replace(/[^0-9]/g, ""); // Remove non-numeric characters
                                            formik.setFieldValue("shareNumber", value);
                                        }}
                                        name="shareNumber"
                                        error={Boolean(formik.touched.shareNumber && formik.errors.shareNumber)}
                                        helperText={formik.touched.shareNumber && formik.errors.shareNumber}
                                        inputProps={{ inputMode: "numeric", maxLength: 4 }}
                                    />
                                </Grid>

                                <Grid size={{ xs: 12 }} md={12}>
                                    <TextField
                                        fullWidth
                                        label="Free Bids After Completion of Each Milestone"
                                        value={formik.values.freeBidsGranted}
                                        onChange={(e) => {
                                            let value = e.target.value;
                                            if (/^\d{0,7}(\.\d{0,2})?$/.test(value)) {
                                                formik.setFieldValue("freeBidsGranted", value);
                                            }
                                        }}
                                        name="freeBidsGranted"
                                        error={Boolean(formik.touched.freeBidsGranted && formik.errors.freeBidsGranted)}
                                        helperText={formik.touched.freeBidsGranted && formik.errors.freeBidsGranted}
                                        inputProps={{ inputMode: "decimal", maxLength: 10 }}
                                    />
                                </Grid>
                                <Grid size={{ xs: 12 }} md={12}>
  <TextField
    fullWidth
    label="Free Bids on Signup (via Referral Code)"
    value={formik.values.freeBidsOnSignup}
    onChange={(e) => {
      const value = e.target.value.replace(/[^0-9]/g, "");
      formik.setFieldValue("freeBidsOnSignup", value);
    }}
    name="freeBidsOnSignup"
    error={Boolean(formik.touched.freeBidsOnSignup && formik.errors.freeBidsOnSignup)}
    helperText={formik.touched.freeBidsOnSignup && formik.errors.freeBidsOnSignup}
    inputProps={{ inputMode: "numeric", maxLength: 4 }}
  />
</Grid>

<Grid size={{ xs: 6 }} md={6}>
  <TextField
    fullWidth
    label="Referred User Free Bids (after first purchase)"
    value={formik.values.referalUserBids}
    onChange={(e) => {
      const value = e.target.value.replace(/[^0-9]/g, "");
      formik.setFieldValue("referalUserBids", value);
    }}
    name="referalUserBids"
    error={Boolean(formik.touched.referalUserBids && formik.errors.referalUserBids)}
    helperText={formik.touched.referalUserBids && formik.errors.referalUserBids}
    inputProps={{ inputMode: "numeric", maxLength: 4 }}
  />
</Grid>

<Grid size={{ xs: 6 }} md={6}>
  <TextField
    fullWidth
    label="Referrer Free Bids (after referral's first purchase)"
    value={formik.values.referredByUserBids}
    onChange={(e) => {
      const value = e.target.value.replace(/[^0-9]/g, "");
      formik.setFieldValue("referredByUserBids", value);
    }}
    name="referredByUserBids"
    error={Boolean(formik.touched.referredByUserBids && formik.errors.referredByUserBids)}
    helperText={formik.touched.referredByUserBids && formik.errors.referredByUserBids}
    inputProps={{ inputMode: "numeric", maxLength: 4 }}
  />
</Grid>



                                <Grid size={{ xs: 12 }} md={12}>
                                    <EdiorJodit
                                        data={formik?.values?.notice}
                                        placeholder="Terms and conditions"
                                        onChange={(html) => {
                                            formik.setFieldTouched("notice", true);
                                            const withoutHtml = html.replace(REMOVEHTML, "").replace(REMOVENBSP, "").trim();
                                            formik.setFieldValue("notice", withoutHtml ? html : "");
                                            setCmsData(html);
                                        }}
                                    />

                                    {formik.touched.notice && formik.errors.notice && (
                                        <p style={{ color: "red", fontSize: "14px" }}>
                                            {formik.errors.notice}
                                        </p>
                                    )}
                                </Grid>
                                <Grid size={{ xs: 12 }} md={12}>
                                    <Select
                                        labelId="status-label"
                                        id="status"
                                        value={formik.values.status}
                                        onChange={(e) =>
                                            formik.setFieldValue("status", e.target.value)
                                        }
                                        fullWidth
                                        error={Boolean(
                                            formik.touched.status && formik.errors.status
                                        )}
                                        displayEmpty
                                        defaultValue=""
                                    >
                                        <MenuItem value="">Select Status</MenuItem>
                                        <MenuItem value='true'>Active</MenuItem>
                                        <MenuItem value='false'>Inactive</MenuItem>
                                    </Select>
                                    {formik.touched.status && formik.errors.status && (
                                        <FormHelperText error>
                                            {formik.errors.status}
                                        </FormHelperText>
                                    )}
                                </Grid>

                                <Grid size={{ xs: 12 }}>
                                    <Box mt={3} width="100%">
                                        <LoadingButton
                                            fullWidth
                                            size="large"
                                            type="submit"
                                            variant="contained"
                                            loading={loading}
                                        >
                                            Update Auction
                                        </LoadingButton>
                                    </Box>
                                </Grid>
                            </Grid>
                        </Form>
                    </FormikProvider>
                </CardContent>
            </CardLayout>
        </Box>
    );
}

export default AddEditCategory;